import { Roles } from "../../constants/roles";
import { RankingsMonthlyTabsForm } from "./rankings-monthly-tabs-form";
import { RankingsMonthlyTabsHandler } from "./rankings-monthly-tabs-handler";
import { RankingsMonthlyTabsListener } from "./rankings-monthly-tabs-listener";

export class RankingsMonthlyTabsSetup {
    public root: HTMLElement;

    public form: RankingsMonthlyTabsForm;

    public handler: RankingsMonthlyTabsHandler;

    public listener: RankingsMonthlyTabsListener;

    public constructor(root: HTMLElement) {
        this.root = root;
        this.form = new RankingsMonthlyTabsForm(root);
        this.handler = new RankingsMonthlyTabsHandler(this.form);
        this.listener = new RankingsMonthlyTabsListener(this.form, this.handler);
    }

    public init(): void {
        if (!(this.root instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;

        this.form.markInitialized();
        this.listener.register();
        this.handler.bootstrap();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement | null): void {
        const root = rootEl || document;
        if (!(root instanceof Document || root instanceof HTMLElement)) return;

        if (root instanceof HTMLElement && root.matches(`[data-role="${Roles.RANKINGS_MONTHLY_TABS}"]`)) {
            const instance = new RankingsMonthlyTabsSetup(root);
            instance.init();
            return;
        }

        const nodes = RankingsMonthlyTabsForm.getRoots(root);
        nodes.forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            const instance = new RankingsMonthlyTabsSetup(node);
            instance.init();
        });
    }
}
